import { render } from "./DownloadTable.vue?vue&type=template&id=303a8488&scoped=true&ts=true"
import script from "./DownloadTable.ts?vue&type=script&lang=ts"
export * from "./DownloadTable.ts?vue&type=script&lang=ts"

import "./DownloadTable.scss?vue&type=style&index=0&id=303a8488&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-303a8488"]])

export default __exports__